import { Component, Input } from '@angular/core';
import { ClientSideListBaseComponent } from 'src/app/common/core/client-side-list-base/client-side-list-base.component';
import { ColDef } from "ag-grid-community";
import { columnDefinitionForecast, columnDefinitionForecastAgenda, columnDefinitionNoTherapist } from './discrepancies.config';
import { Discrepancies, DiscrepanciesItem } from 'src/app/common/interfaces/home/tasks.interface';

@Component({
  selector: 'app-discrepancies',
  standalone: true,
  templateUrl: './discrepancies.component.html',
  styleUrls: ['./discrepancies.component.scss'],
  imports: [ClientSideListBaseComponent]
})
export class DiscrepanciesComponent {
  columnDefinitionForecastAgenda!: ColDef[];
  columnDefinitionForecast!: ColDef[];
  columnDefinitionNoTherapist!: ColDef[];
  @Input() discrepancies!: Discrepancies;
  rowDataForecast!: DiscrepanciesItem[];
  rowDataForecastAgenda!: DiscrepanciesItem[];
  rowDataNoTherapist!: DiscrepanciesItem[]

  ngOnInit(){
    this.columnDefinitionForecastAgenda = columnDefinitionForecastAgenda(this);
    this.columnDefinitionForecast = columnDefinitionForecast(this);
    this.columnDefinitionNoTherapist = columnDefinitionNoTherapist(this);
    this.rowDataForecast = this.discrepancies['Forecast Minutes but No Agenda'];
    this.rowDataForecastAgenda = this.discrepancies['Forecast Does Not Match Agenda'];
    this.rowDataNoTherapist = this.discrepancies['Patient on Agenda but Not Assigned to Therapist']
  }
}
